/*
 view-amountfee

 table-basic
 <table class="table-basic u-mb2 u-pr1">
 <tfoot>
 <tr>
 <td>Updated Balance</td>
 <td class="u-text-r">£456,10</td>
 </tr>
 </tfoot>
 <tbody>
 <tr>
 <td>Deposit Amount:</td>
 <td class="u-text-r">100.00 SEK</td>
 </tr>
 <tr>
 <td>Deposit Fee (2.5%):</td>
 <td class="u-text-r">2.50 SEK</td>
 </tr>
 <tr>
 <td>Earned Points</td>
 <td class="u-text-r">8</td>
 </tr>
 </tbody>
 </table>

 */
import core from '../../common/lib/core.js';
import viewTextkeys from '../../commonview/lib/view-textkeys.js';
import viewSpinnerCreator from '../../commonview/lib/view-spinnersmall.js';
import currencyFormatter from './../../../libs/currency-formatter.js';
import { getLocale } from './../../../libs/locale.js';

const classnameOpen = 'u-show';
const classnameClose = 'u-hide';
const create = core.create;
let textkeysObj = {};
const ABSENTVALUE = '-';

function createBonustitleHead(txt) {
	const elm = create({
		type: 'span',
		class: 'payment__bonus-titlehead'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createTableCellStart(txt) {
	const elm = create({
		type: 'td'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}


function assembleElements(elements = {}) {
	const elms = {};
	/* create elements if not already existing */
	elms.wrap = (elements.wrap || create('div', 'amountfee-wrap'));
	elms.wrapTable = (elements.wrapTable || create('table', 'table-basic'));
	elms.tablefoot = (elements.tablefoot || create('tfoot'));
	elms.tablebody = (elements.tablebody || create('tbody'));
	/**/
	elms.wrapbalance = (elements.wrapbalance || create('tr'));
	elms.wrapbonus = (elements.wrapbonus || create('tr'));
	elms.wrapfee = (elements.wrapfee || create('tr'));
	elms.wrapbillingamount = (elements.wrapbillingamount || create('tr'));
	elms.wrapdepositamount = (elements.wrapdepositamount || create('tr'));
	/* bonus amount added to deposit */
	elms.bonustitle = (elements.bonustitle || createTableCellStart());
	elms.bonustitlehead = (elements.bonustitlehead || createBonustitleHead(textkeysObj['bonus-amount']));
	elms.bonusconditionmsg = (elements.bonusconditionmsg || create('span', 'payment__bonus-condition'));
	elms.bonuscontent = (elements.bonuscontent || create('td', 'u-text-r'));
	/* amount to be added to users account */
	elms.depositamounttitle = (elements.depositamounttitle || createTableCellStart(textkeysObj['deposit-amount']));
	elms.depositamountcontent = (elements.depositamountcontent || create('td', 'u-text-r'));
	/* fee in percent and currence */
	elms.feetitle = (elements.feetitle || createTableCellStart(textkeysObj['deposit-fee']));
	elms.feecontent = (elements.feecontent || create('td', 'u-text-r'));
	/* amount to be payed by user */
	elms.billingamounttitle = (elements.billingamounttitle || createTableCellStart(textkeysObj['debited-amount']));
	elms.billingamountcontent = (elements.billingamountcontent || create('td', 'u-text-r'));
	/* new balance after deposit is done */
	elms.balancetitle = (elements.balancetitle || createTableCellStart(textkeysObj['new-balance']));
	elms.balancecontent = (elements.balancecontent || create('td', 'u-text-r'));
	/* hierachy */
	elms.bonustitle.appendChild(elms.bonustitlehead);
	elms.bonustitle.appendChild(elms.bonusconditionmsg);
	elms.wrapbonus.appendChild(elms.bonustitle);
	elms.wrapbonus.appendChild(elms.bonuscontent);
	elms.wrapbalance.appendChild(elms.balancetitle);
	elms.wrapbalance.appendChild(elms.balancecontent);
	elms.wrapdepositamount.appendChild(elms.depositamounttitle);
	elms.wrapdepositamount.appendChild(elms.depositamountcontent);
	elms.wrapbillingamount.appendChild(elms.billingamounttitle);
	elms.wrapbillingamount.appendChild(elms.billingamountcontent);
	elms.wrapfee.appendChild(elms.feetitle);
	elms.wrapfee.appendChild(elms.feecontent);
	elms.tablebody.appendChild(elms.wrapbonus);
	elms.tablebody.appendChild(elms.wrapdepositamount);
	elms.tablebody.appendChild(elms.wrapfee);
	elms.tablebody.appendChild(elms.wrapbillingamount);
	elms.tablefoot.appendChild(elms.wrapbalance);
	elms.wrapTable.appendChild(elms.tablefoot);
	elms.wrapTable.appendChild(elms.tablebody);
	elms.wrap.appendChild(elms.wrapTable);
	elms.assembled = true;
	return elms;
}

function setContent(elm, txt) {
	if (elm) {
		elm.innerHTML = txt; // eslint-disable-line no-param-reassign
	}
}

function getFormattedAmount(amount, currency) {
	if (amount === undefined && currency === '') {
		return '...';
	}
	return currencyFormatter.format(amount, currency, getLocale());
}

function updateDepositSummary(elements, stateFromFetchFeesAndLimits) {
	/* Bonusfield: conditions: when bonusamount is calculated from conditions build from percentage and max/min-values */
	const st = stateFromFetchFeesAndLimits;
	const amountAndFee = st.amountAndFee;
	const amountWithoutFee = st.amountWithoutFee;
	const bonusAmount = st.bonusAmount;
	const bonusCondition = (st.bonusCondition || '');
	const bonusWasFound = st.bonusWasFound;
	const feeAmount = st.feeAmount;
	const newBalance = st.newBalance;
	const playerCurrency = (st.playerCurrency || '');
	const selectedCurrency = (st.selectedCurrency || '');
	const formattedBonus = ((bonusWasFound && bonusAmount) ? getFormattedAmount(bonusAmount, selectedCurrency) : ABSENTVALUE);
	let formattedAmount = getFormattedAmount(amountWithoutFee, selectedCurrency);
	let formattedFee = getFormattedAmount(feeAmount, selectedCurrency);
	let formattedTotal = getFormattedAmount(amountAndFee, playerCurrency);
	let formattedNewBalance = getFormattedAmount(newBalance || 0, playerCurrency);
	formattedAmount = (formattedAmount || ABSENTVALUE);
	formattedFee = (formattedFee || ABSENTVALUE);
	formattedTotal = (formattedTotal || ABSENTVALUE);
	formattedNewBalance = (formattedNewBalance || ABSENTVALUE);
	/* Bonusfield: show conditions for percentage */
	setContent(elements.bonusconditionmsg, bonusCondition);
	/* Bonusfield: show amount and conditions. */
	setContent(elements.bonuscontent, formattedBonus);
	/* CreditAmountfield: show the same as typed into the inputfield and with currency unit. For some reason two fields for credit amount? */
	setContent(elements.depositamountcontent, formattedAmount);
	setContent(elements.feecontent, formattedFee);
	setContent(elements.billingamountcontent, formattedTotal);
	/* New balance: the amount from the inputfield added with selected bonus */
	setContent(elements.balancecontent, formattedNewBalance);
}

function show(elm) {
	core.removeClass(elm, classnameClose);
	core.addClass(elm, classnameOpen);
}

function hide(elm) {
	core.removeClass(elm, classnameOpen);
	core.addClass(elm, classnameClose);
}

export default {
	create() {
		let elements = {};
		textkeysObj = viewTextkeys.depositflow();
		elements = assembleElements(elements);
		const viewSpinner = viewSpinnerCreator.create({
			sibling: elements.wrap
		});
		elements.wrap.appendChild(viewSpinner.wrap);
		return {
			wrap: elements.wrap,
			show() {
				show(elements.wrap);
			},
			hide() {
				hide(elements.wrap);
			},
			update(state) {
				if (state.fetch_fees_and_limits) {
					const st = state.fetch_fees_and_limits;
					const pending = st.pending;
					const err = st.error;
					const exceededLimits = (st.limitAbove || st.limitReached || st.limitBelow);
					const amountAndFee = ((pending || err || exceededLimits) ? null : st.feeSumAmount);
					const amountWithoutFee = ((pending || err || exceededLimits) ? null : st.feeBasedOn);
					const bonusAmount = ((pending || err || exceededLimits) ? null : st.bonusAmount);
					const bonusCondition = ((pending || err || exceededLimits) ? null : (st.bonus_condition || ''));
					const bonusWasFound = ((pending || err || exceededLimits) ? null : st.bonusWasFound);
					const feeAmount = ((pending || err || exceededLimits) ? null : st.feeAmount);
					const playerCurrency = ((pending || err || exceededLimits) ? null : st.playerCurrency);
					const newBalance = ((pending || err || exceededLimits) ? null : st.newBalance);
					const selectedCurrency = ((pending || err || exceededLimits) ? null : (st.selectedCurrency || ''));
					const stData = {
						amountAndFee,
						amountWithoutFee,
						bonusAmount,
						bonusCondition,
						bonusWasFound,
						feeAmount,
						playerCurrency,
						newBalance,
						selectedCurrency
					};
					if (pending) {
						viewSpinner.show();
					} else {
						viewSpinner.hide();
					}
					updateDepositSummary(elements, stData);
				}
			},
			close() {
				elements = core.deleteElementsInObjectExcept(elements, [], 'view-amounfee:276');
				viewSpinner.close();
				return null;
			}
		};
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/payment/lib/view-amountfee.js